import { getRequest } from '../../methods';

const getCustomGoalFilters = () => getRequest('users/me/custom_goal_filters');

const customGoalFilters = {
  getCustomGoalFilters,
};

export default customGoalFilters;
